import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import SupplierPaymentForm from '../../components/SupplierPayment/SupplierPaymentForm';
import { useSupplierPayment } from '../../store/supplierPaymentContext';
import { useParams, useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const SupplierPaymentFormPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const { supplierPayments, fetchSupplierPayments } = useSupplierPayment();
    const [editSupplierPayment, setEditSupplierPayment] = useState<any | undefined>(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        fetchSupplierPayments();
    }, []);

    useEffect(() => {
        if (id) {
            const payment = supplierPayments.find(r => r.id === id || r.id === id);
            setEditSupplierPayment(payment);
        } else {
            setEditSupplierPayment(undefined);
        }
    }, [id, supplierPayments]);

    return (
        <div style={{ padding: 16 }}>
            <Card title={editSupplierPayment ? t('edit_supplier_payment') : t('add_supplier_payment')}>
                <SupplierPaymentForm
                    editSupplierPayment={editSupplierPayment}
                    onFinishEdit={() => navigate('/supplier-payments/list')}
                />
            </Card>
        </div>
    );
};

export default SupplierPaymentFormPage;
